export const COURSE_TYPES = {
	VIDEO_LEARNING: "VIDEO_LEARNING",
	LIVE_WEBINAR: "LIVE_WEBINAR",
	MENTOR_CONSULTATION: "MENTOR_CONSULTATION",
	INHOUSE_TRAINING: "INHOUSE_TRAINING",
	FREE_TRAINING: "FREE_TRAINING",
} as const;

export type CourseType = keyof typeof COURSE_TYPES;

export const SKILL_COMBO_TYPES = {
	ONAIR_FOUNDATION: "ONAIR_FOUNDATION",
	ONAIR_CORESKILL: "ONAIR_CORESKILL",
	ONAIR_RESKILL: "ONAIR_RESKILL",
} as const;

export type SkillComboType = keyof typeof SKILL_COMBO_TYPES;

export const EXTERNAL_URLS = {
	ONAIR_ONLINE_COURSE: "https://onair.today/online-course",
	ONAIR_EVENTS: "https://onair.today/events",
	ONAIR_HOSTS: "https://onair.today/hosts",
	LD_VIETNAM: "https://ldvietnam.com",
	ONAIR_FOUNDATION:
		"https://onair.today/online-course?categories=cm4pyx7v00002smcysjtfry8b%2Ccm5g5lt3u001yu5ku1thlowmg%2Ccm5g5m84h0020u5ku2hilc9kw",
	ONAIR_CORESKILL:
		"https://onair.today/online-course?categories=cm5g5t5yc0045u5kuxk5k6471%2Ccm5g5tm1u004eu5ku2hwv2sbc%2Ccm5g5tuqj004ku5kubjo3vc4h%2Ccm5g5u3at004ru5kufonyy6un%2Ccm5g5ufj6004uu5kuhrmuss3g%2Ccm5g5ucff004su5kuvq27vy9u%2Ccm5g5v1dl0055u5kuwsezoqk2%2Ccm5g5vb170057u5kuao7cy3t5",
	ONAIR_RESKILL: "https://onair.today/reskill",
} as const;

export const openVideoLearning = () => {
	if (typeof window !== "undefined") {
		window.open(EXTERNAL_URLS.ONAIR_ONLINE_COURSE, "_blank");
	}
};

export const openLiveWebinar = () => {
	if (typeof window !== "undefined") {
		window.open(EXTERNAL_URLS.ONAIR_EVENTS, "_blank");
	}
};

export const openMentorConsultation = () => {
	if (typeof window !== "undefined") {
		window.open(EXTERNAL_URLS.ONAIR_HOSTS, "_blank");
	}
};

export const openFreeTraining = () => {
	if (typeof window !== "undefined") {
		window.open(EXTERNAL_URLS.LD_VIETNAM, "_blank");
	}
};

export const openOnAirFoundation = () => {
	if (typeof window !== "undefined") {
		window.open(EXTERNAL_URLS.ONAIR_FOUNDATION, "_blank");
	}
};

export const openOnAirCoreSkill = () => {
	if (typeof window !== "undefined") {
		window.open(EXTERNAL_URLS.ONAIR_CORESKILL, "_blank");
	}
};

export const openOnAirReSkill = () => {
	if (typeof window !== "undefined") {
		window.open(EXTERNAL_URLS.ONAIR_RESKILL, "_blank");
	}
};
